import { bindActionCreators } from 'redux';
import { connect } from '../../../../common/react-redux';
import { screenreaderNotification as screenreaderNotificationAction } from '../../../../common/actions/alerts';
import ItemAnalysisRow from './presenter';
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    screenreaderNotification: bindActionCreators(screenreaderNotificationAction, dispatch)
  };
};
export default connect(null, mapDispatchToProps)(ItemAnalysisRow);